const styles = {
  textField: {
    backgroundColor: "white",
    "& .MuiInputBase-root": { backgroundColor: "white" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  },
  button: {
    textTransform: "none",
    mt: 1,
    borderRadius: 4,
    color: "green.light",
  },
};

export default styles;
